// ================================================================
// FILE: Pos.tsx
// (route file for admin-menu/manage-thirdparty-services/pos-ecommerce/pos —
// thin wrapper so the route config doesn't need to change)
// ================================================================
import ThirdPartyConnectForm from "./ThirdPartyConnectForm";

const Pos = () => <ThirdPartyConnectForm />;

export default Pos;
